/**
 * Manuscript illustrations for the /guides pages, keyed by the guide slug
 * (`deploy-<slug>` in the URL; "guides" is the index). Same series and hero
 * layout as the product art in productArt.ts.
 *
 * To add art: drop `<slug>.webp` into `public/guides/art/` and add the slug.
 */
const GUIDE_ART = new Set([
  "guides",
  "monorepo",
  "python",
  "nodejs",
  "laravel",
  "go",
  "ruby",
  "rust",
  "react",
  "nextjs",
  "vue",
  "svelte",
  "astro",
  "static-sites",
]);

export function guideArt(slug: string): string | undefined {
  return GUIDE_ART.has(slug) ? `/guides/art/${slug}.webp` : undefined;
}
